import { Button } from "@/components/ui";

import type { LeafOffer, PickProps, ReviewOption } from "./LeafTabs.types";

export function LeafOfferNote({
  offer,
  options,
  picked,
  onPick,
}: PickProps & { offer: LeafOffer; options: ReviewOption[] }) {
  const p = options.find((option) => option.key === offer.key)?.p;
  return (
    <div className="flex items-start justify-between gap-3 border-b border-slate-200 dark:border-slate-700 px-3 py-2 text-sm">
      <div className="space-y-0.5">
        <p className="text-slate-700 dark:text-slate-300">
          Suggested new name: <span className="font-mono">{offer.key}</span> —
          unsure ({typeof p === "number" ? p.toFixed(2) : "no score"})
        </p>
        {offer.description && (
          <p className="text-xs text-slate-500 dark:text-slate-400">
            {offer.description}
          </p>
        )}
      </div>
      <Button
        variant="outline"
        disabled={picked === offer.key}
        onClick={() => onPick(offer.key)}
      >
        Use this name
      </Button>
    </div>
  );
}
